import { FORM_FIELDS } from '../../../constants';
import { formDataToScoreFacade } from '../../../store/adapters/formStore';
import { ScoreClientResponse } from '../../../services/amazingScoring/amazingScoring.types';
import { provider } from '../../client';

type TScoreData = { score?: number | null; scoreType?: ScoreClientResponse['scoreType']; isHit?: boolean };

export const getScoring = async (formData: FE.FormData): Promise<TScoreData> => {
    const requestParams = formDataToScoreFacade(formData);
    const scoreResult = await provider.postScoringData(requestParams);

    return { score: scoreResult?.scorePoint || null, scoreType: scoreResult?.scoreType };
};

export const scoringToFormData = ({ score, scoreType, isHit }: TScoreData): FE.FormData => {
    if (scoreType === 'equifax') {
        return {
            [FORM_FIELDS.SCORE_EKVI]: score,
        };
    }

    return {
        [FORM_FIELDS.SCORE_GEN7_CL]: score,
        [FORM_FIELDS.SCORE_GEN7_CL_HIT]: isHit,
    };
};
